import React from "react";
import styles from "./styles.module.scss";

const Modal = ({ children, width, className }) => {
  return (
    <div className={`${styles.modalWrapper} `}>
      <div
        className={`${styles.modalContainer} ${className ? className : ""} ${
          styles.zoomIn
        }`}
        style={{ width: width ? width : "" }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
